import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap';
import Grid from '@mui/material/Grid2';
import TaskDisccuss from './TaskDisccuss';
import TaskDisccussCase from '../CaseDetails/TaskDisccussCase';

function OnboardingDiscussTab({showCase, casediscuss}) {

    const [activeTabCase, setActiveTabCase] = useState("taskdiscuss");
  return (
    <Grid size={{sm:12}} container className="tab_controllers control_splits" alignContent="flex-start">
        <Tabs
            activeKey={activeTabCase}
            onSelect={(key) => setActiveTabCase(key)}
            defaultActiveKey="taskdiscuss"
            id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
        >
            <Tab eventKey="taskdiscuss" title="Task Discussion">
                {activeTabCase === "taskdiscuss" && <TaskDisccuss casediscuss={casediscuss}/>}
            </Tab>
            {showCase && 
            <Tab eventKey="casediscuss" title="Case Discussion">
                {activeTabCase === "casediscuss" && <TaskDisccussCase casediscuss={casediscuss}/>}
            </Tab>
            }
        </Tabs>
    </Grid>
  )
}

export default OnboardingDiscussTab
